// ComingSoonOverlay.jsx
import "./ComingSoonOverlay.css";
export default function ComingSoonOverlay() {
  return (
    <div className="cs-overlay">
      <div className="cs-card">
        <h1>Coming Soon...</h1>
        <p>
          This section is currently under development.
          <br />
          We’re crafting a refined experience for you.
        </p>
      </div>
    </div>
  );
}
